import { Box, Card, CardContent, Typography } from "@mui/material";
import { Trans } from "react-i18next";
import { getOrgUserDetails } from "apps/web/src/pages/Auth/OrgUtils";
import { useUser } from "apps/web/src/utils/tokens";
import { AthleteEdsaResultsFragment, TeamPageTeamFragment } from "../../../../types";
import DashboardCard from "../Card";
import { DownloadButton } from "./DownloadButton";
import { EDSACardDisabled } from "./EDSACardDisabled";

interface EDSACardProps {
  athletes: readonly AthleteEdsaResultsFragment[];
  team: TeamPageTeamFragment;
  enabled: boolean;
}

export const EDSACard = ({ athletes, team, enabled }: EDSACardProps) => {
  const user = useUser();
  const { hasRoleDietitian } = getOrgUserDetails(user);
  const numberOfAthletesCompleted = athletes.filter(a => a.lastEdsaResult !== null).length;
  const totalAthletes = team.athletes.length;
  const exportButton = <DownloadButton data={athletes} teamName={team.name} />;
  return (
    <DashboardCard title="EDSA" options={hasRoleDietitian ? exportButton : null}>
      <Box sx={{ width: "100%", height: "100%" }}>
        {athletes && enabled ? (
          <Card>
            <CardContent sx={{ width: "100%", p: 2 }} tabIndex={0}>
              <Typography variant="body2">
                <Trans
                  i18nKey="team.dashboard.edsa.cardContent"
                  values={{ numberOfAthletesCompleted, totalAthletes }}
                  components={{ a: <a /> }}
                />
              </Typography>
            </CardContent>
          </Card>
        ) : (
          <EDSACardDisabled />
        )}
      </Box>
      <div />
    </DashboardCard>
  );
};
